import { type TagProps } from '@naf-simba/elements-tag';
import { ColorVariant } from '../../../types/featuredBenefitBlockType';

type LabelVariant = ColorVariant | 'signature' | 'spruce' | 'moss' | 'white' | 'info' | 'outline';

export function getLabelVariant(variant?: LabelVariant): Pick<TagProps, 'color' | 'shade'> {
  switch (variant) {
    case ColorVariant.signature:
    case 'signature':
      return { color: 'primary' };
    case ColorVariant.secondary:
    case 'secondary':
    case 'moss':
      return { color: 'secondary', shade: 'light' };
    case ColorVariant.outline:
    case 'outline':
    case 'white':
      // Old `white` Label = white background, black text. `alternative` is the
      // Tag equivalent (flat color, so `shade` is intentionally omitted).
      return { color: 'alternative' };
    case ColorVariant.spruce:
    case 'spruce':
      return { color: 'secondary' };
    case ColorVariant.critical:
      return { color: 'critical' };
    case ColorVariant.information:
    case 'info':
      return { color: 'information' };
    default:
      return { color: 'primary' };
  }
}
